import * as React from 'react';
import { RouteComponentProps, browserHistory } from 'react-router';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';
import { IStore } from 'redux/IStore';
import {
	getShopCardByCode,
	followShop,
	changeTabAndGetRequiredData,
	resetData,
	setIsMyShop,
	getShopCardFollowButtonData,
	unfollowShop,
	setShopStatus,
} from 'modules/shop/shopcard';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { showModal, closeModal } from 'modules/modal';
import { IShopCard } from 'models/shop/shopcard';
import * as c from 'models/constants';
import { ICropImageData, IAuthContext, ITranslateProps } from 'models/common';
import { ErrorPage, ProductSearchResults } from 'containers';
import { updateProfileImage, updateCoverImage } from 'redux/modules/image';
import Helmet from 'react-helmet';
import { resetSearchData } from 'redux/modules/search/productsearchresults';
import { RootCategory, SearchUsage, ShopStatus } from 'models';
import { AuthConsumer } from 'containers';
const { asyncConnect } = require('redux-connect');
import { formatInteger, getGuidFromString, getIdFromObject, goToCard } from 'helpers/common';
import renderIcon from 'helpers/renderIcon';
import { CoverPicture } from 'components/Profile/CoverPicture';
import { ShopFollowers } from 'containers/Shop/ShopFollowers';
import { ShopAbout } from '../ShopAbout';
import ShopReviews from '../ShopReviews';
import { ShopStaffMembers } from '../ShopStaffMembers';
import { IOffice, IOfficeListItem } from 'models/shop/office';
import { Dispatch } from 'react-redux';
import { ShopCardServices } from './ShopCardServices';
import { ShopCardOfficeDetails } from './ShopCardOfficeDetails';
import { ShopCardOfficesMap } from './ShopCardOfficesMap';
import { ButtonRound, EllipseGreyWhiteButton } from 'components/Common/Button';
import { toggleProductFilter } from 'redux/modules/search/shopsearchresults';
import { SettingsDropdown } from './SettingsDropdown';
import { LoadingOverlayWrapper } from 'components/Loader';
import { thumbUrl } from 'helpers/common';
import { ShopCardOfficeStaff } from './ShopCardOfficeStaff';
import { putActiveMembersSuccess } from 'redux/modules/user/userpreferences';
import { IExtendedRouteProps } from 'routes/extendedroute';
import { isRestrictedModeQuery, momentWithTimezone } from 'redux/modules/shop/helpers';
import { AvatarSmall } from 'components';
import { formatWorkTime } from 'helpers/bookingTemplates';

interface IProps
	extends RouteComponentProps<IParams, {}>,
		ITranslateProps,
		ReturnType<typeof mapStateToProps>,
		ReturnType<typeof mapDispatchToProps> {
	context?: IAuthContext;
	baseUrl?: string;
}

interface IParams {
	id: string;
	code: string;
	officeId?: string | undefined;
}
interface IState {
	hoverOver?: IOfficeListItem['id'];
	aboutMeetTheTeamOfficeSelected: number;
	activeMembers: any[];
}

const tabsNamespace = 'shopcardtabs';

@asyncConnect([
	{
		promise: ({ store: { dispatch, getState }, params }) => {
			const shopCardData = (getState as () => IStore)().shopcard;
			if (
				(!shopCardData.shopcard && params.code) ||
				!shopCardData.shopcard.offices ||
				(shopCardData.shopcard && params.code && params.code !== shopCardData.shopcard.code)
			) {
				return Promise.all([dispatch(getShopCardByCode(params.code)), dispatch(resetSearchData())]);
			}
		},
	},
])
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopCardWithForm extends React.Component<IProps, IState> {
	private productsRef: React.RefObject<HTMLDivElement>;
	private mainRef: React.RefObject<HTMLDivElement>;

	constructor(props) {
		super(props);

		this.editProfilePicture = this.editProfilePicture.bind(this);
		this.editCoverPicture = this.editCoverPicture.bind(this);
		this.handleOnEditProfileClick = this.handleOnEditProfileClick.bind(this);
		this.handleOnMessageClick = this.handleOnMessageClick.bind(this);
		this.navigateToShopFollowers = this.navigateToShopFollowers.bind(this);
		this.followShop = this.followShop.bind(this);
		this.unfollowShop = this.unfollowShop.bind(this);
		this.changeTabAndGetRequiredData = this.changeTabAndGetRequiredData.bind(this);
		this.goToCard = this.goToCard.bind(this);
		this.approveShop = this.approveShop.bind(this);
		this.handleLocationChange = this.handleLocationChange.bind(this);

		this.productsRef = React.createRef<HTMLDivElement>();
		this.mainRef = React.createRef<HTMLDivElement>();

		this.state = {
			hoverOver: undefined,
			aboutMeetTheTeamOfficeSelected: 0,
			activeMembers: [],
		};
	}

	public componentDidMount() {
		this.loadData();
		this.checkIfShopOwner();
	}

	public componentDidUpdate(prevProps: IProps) {
		if (
			!prevProps.shopCardData.shopcard ||
			(!prevProps.userPreferences.id && this.props.userPreferences.id) ||
			(!prevProps.userPreferences.userShops && this.props.userPreferences.userShops) ||
			prevProps.params.code != this.props.params.code
		) {
			this.checkIfShopOwner();
		}
		this.loadData();
		if (prevProps.shopCardData?.shopcard?.id !== this.props.shopCardData?.shopcard?.id) {
			this.changeTabAndGetRequiredDataShort();
		}
	}

	public componentWillUnmount(): void {
		this.props.resetData();
	}

	private loadData() {
		const code = this.props.params.code;
		const officeId = this.props.params.officeId;
		const shopCard = this.props.shopCardData.shopcard;
		const offices = shopCard?.offices?.filter((o) => o.shopId === shopCard.id);
		if ((shopCard?.code !== code || !offices) && !this.props.shopCardData.isFetching) {
			this.props.getShopCardByCode(code);
		}
		if (
			offices?.length &&
			offices.length === 1 &&
			shopCard?.code === this.props.params.code &&
			(!officeId || !offices.map(getIdFromObject).includes(officeId))
		) {
			const defaultId = offices.find((o) => o.isDefault)?.id;
			const firstId = offices[0].id;

			let membersOfficeId = undefined;
			const role = (this.props.userPreferences.userRoles || []).find(
				(role) => role.role === 'Member' && role?.type == 'Office' && role?.objInfo?.attributes?.ShopId === shopCard.id,
			);
			// If a user is a member of a certain office that is not the default office of the shop, we have to redirect the user to its office
			if (role) {
				membersOfficeId = role.objId;
			}

			return this.handleLocationChange(membersOfficeId || defaultId || firstId, true);
		}
	}

	private checkIfShopOwner() {
		if (this.props.shopCardData.shopcard?.id) {
			if (
				this.props.shopCardData.shopcard.ownerId === this.props.userPreferences.id ||
				this.props.shopCardData.shopcard?.admins?.some((admin) => this.props.userPreferences.id == admin.id)
			) {
				this.props.setIsMyShop(true);
			} else {
				this.props.getShopCardFollowButtonData();
			}
		}
	}

	private onServicesMemberHandleClick = (member) => {
		// maybe add saving to redux state
		const activeMembers = this.state.activeMembers;
		activeMembers.push(member);
		this.setState({ activeMembers: [...member] });

		this.props.dispatch(putActiveMembersSuccess(activeMembers[activeMembers.length - 1]));
	};

	private get shop(): IShopCard | undefined {
		const code = this.props.params.code;
		if (this.props.shopCardData.shopcard?.code === code) {
			return this.props.shopCardData.shopcard;
		}
	}

	private get office(): IOffice | undefined {
		const officeId = this.props.params.officeId;
		if (!officeId) {
			return undefined;
		}
		const shop = this.shop;
		if (!shop?.offices) {
			return undefined;
		}
		return shop.offices.find((o) => o.id === officeId);
	}

	private handleOnEditProfileClick() {
		browserHistory.push(`/shop/${this.props.shopCardData.shopcard.id}/edit/general`);
	}

	private handleOnMessageClick() {
		window.location.href = `mailto:${this.props.shopCardData.shopcard.email}`;
	}

	private editProfilePicture() {
		this.props.showModal('CropImageModal', {
			type: c.NODE_TYPE_SHOP,
			closeModal: this.props.closeModal,
			saveImage: this.props.updateProfileImage,
			modalTitle: this.props.t('User_UserCard_ProfilePicture'),
			modalSize: 'small',
			imageId: this.props.shopCardData ? getGuidFromString(this.props.shopCardData.shopcard.picture) : undefined,
			entityReferenceId:
				this.props.shopCardData.shopcard && this.props.shopCardData?.shopcard?.id
					? this.props.shopCardData?.shopcard?.id
					: '0',
			cropOptions: {
				...c.DEFAULT_CROP_OPTIONS,
				aspectRatio: c.ASPECT_RATION_SHOP_PROFILE_PICTURE,
				rotatable: true,
			},
			imageType: 'profile',
		});
	}

	private editCoverPicture() {
		this.props.showModal('CropImageModal', {
			type: c.NODE_TYPE_SHOP,
			closeModal: this.props.closeModal,
			saveImage: this.props.updateCoverImage,
			modalTitle: this.props.t('PortalPage_Section_Manage_Common_CoverPicture'),
			modalSize: 'small',
			imageId: this.props.shopCardData ? getGuidFromString(this.props.shopCardData.shopcard.coverPicture) : undefined,
			entityReferenceId:
				this.props.shopCardData.shopcard && this.props.shopCardData?.shopcard?.id
					? this.props.shopCardData?.shopcard?.id
					: '0',
			cropOptions: {
				...c.DEFAULT_CROP_OPTIONS,
				aspectRatio: c.ASPECT_RATION_SHOP_COVER_PICTURE,
			},
			imageType: 'shopBanner',
		});
	}

	private followShop(isAuthenticated, signinRedirect) {
		if (isAuthenticated()) {
			this.props.followShop(this.props.shopCardData.shopcard.id);
		} else {
			signinRedirect();
		}
	}

	private unfollowShop(isAuthenticated, signinRedirect) {
		if (isAuthenticated()) {
			this.props.unfollowShop(this.props.shopCardData.shopcard.id);
		} else {
			signinRedirect();
		}
	}

	private navigateToShopFollowers(e: React.SyntheticEvent) {
		e.preventDefault();
		this.props.changeTabAndGetRequiredData(
			c.USERCARD_TAB_FOLLOWERS,
			this.props.shopCardData.shopcard.id,
			null,
			null,
			null,
			null,
			null,
			null,
			null,
			true,
		);
	}

	private changeTabAndGetRequiredDataShort(
		e: React.SyntheticEvent = null,
		selectedTab: string = c.SHOPCARD_TAB_SERVICES,
	) {
		if (!this.props.shopCardData?.shopcard?.id) {
			return;
		}
		let categoryId: number = RootCategory.Women;
		const parsedCategoryId = parseInt(this.props.location.query.cat, 10);
		if (!isNaN(parsedCategoryId)) {
			categoryId = parsedCategoryId;
		}
		let order: number = null;
		const parsedOrderId = parseInt(this.props.location.query.o, 10);
		if (!isNaN(parsedOrderId)) {
			order = parsedOrderId;
		}
		let r1: number = null;
		const parsedr1 = parseInt(this.props.location.query.r1, 10);
		if (!isNaN(parsedr1)) {
			r1 = parsedr1;
		}
		let r2: number = null;
		const parsedr2 = parseInt(this.props.location.query.r2, 10);
		if (!isNaN(parsedr2)) {
			r2 = parsedr2;
		}
		let r3: boolean = null;
		if (this.props.location.query.r3) {
			r3 = this.props.location.query.r3 === 'true';
		}
		let r4: string = null;
		if (this.props.location.query.r4) {
			r4 = this.props.location.query.r4;
		}
		let r5: string = null;
		if (this.props.location.query.r5) {
			r5 = this.props.location.query.r5;
		}
		this.changeTabAndGetRequiredData(
			e,
			selectedTab,
			this.props.shopCardData.shopcard.id,
			categoryId,
			order,
			r1,
			r2,
			r3,
			r4,
			r5,
		);
	}

	private changeTabAndGetRequiredData(
		e: React.SyntheticEvent,
		selectedTab: string,
		shopId: string,
		categoryId: number,
		order: number,
		r1: number,
		r2: number,
		r3: boolean,
		r4: string,
		r5: string,
	) {
		if (e) {
			e.preventDefault();
		}

		if (selectedTab === c.SHOPCARD_TAB_PRODUCTS && this.productsRef.current) {
			document.documentElement.scrollTop += this.productsRef.current.getBoundingClientRect().top;
		} else if (selectedTab === c.SHOPCARD_TAB_OVERVIEW && this.mainRef.current) {
			document.documentElement.scrollTop += this.mainRef.current.getBoundingClientRect().top;
		}

		this.props.changeTabAndGetRequiredData(selectedTab, shopId, categoryId, order, r1, r2, r3, r4, r5);
	}

	private goToCard(id: string, type: string, target: string) {
		goToCard(this.props.dispatch, id, type, target);
	}

	private approveShop() {
		this.props.setShopStatus(this.props.shopCardData.shopcard.id, ShopStatus.Approved);
	}

	private handleLocationChange(officeId: string, replace?: boolean) {
		setTimeout(() => {
			browserHistory[replace ? 'replace' : 'push'](
				`/${this.props.baseUrl || 'shop'}/${this.props.params.code}/${officeId}`,
			);
		}, 10);
	}

	public render() {
		if (this.props.shopCardData.error) {
			return <ErrorPage {...this.props} message={this.props.shopCardData.message} />;
		}
		const { t, shopCardData, productSearchResults, userPreferences } = this.props;
		const { isMyShop, selectedTab, shopcard } = this.props.shopCardData;

		const shopLoaded = this.props.shopCardData.shopcard?.id;

		const { name, description, picture, followersCount, votes, averageRating, code } =
			this.props.shopCardData.shopcard || {};
		const shopUrl = this.props.baseUrlClient + `/${this.props.baseUrl || 'shop'}/` + code;

		const route: IExtendedRouteProps =
			(this.props.routes?.length ? this.props.routes[this.props.routes.length - 1] : null) || this.props.route;
		const restrictedMode = route?.restrictedMode || isRestrictedModeQuery(this.props.location);

		let approveButton: JSX.Element = null;
		if (
			shopLoaded &&
			userPreferences.id &&
			userPreferences.isAdministrator &&
			shopcard.status !== ShopStatus.Approved
		) {
			approveButton = (
				<EllipseGreyWhiteButton onClick={this.approveShop} className="approveShop">
					<span>{t('Shop_ShopCard_About_Button_Approve')}</span>
				</EllipseGreyWhiteButton>
			);
		}

		let shopPictureToDisplay: string = '';
		if (shopCardData?.shopcard?.coverPicture) {
			shopPictureToDisplay = shopCardData?.shopcard?.coverPicture;
		}
		if (!shopPictureToDisplay) {
			shopPictureToDisplay = require('containers/Html/icons/cover_salon_default.svg');
		}

		let editUploadButton: JSX.Element = null;

		// Needs to be shop owner (backend rejects anybody but shop owner to change the cover picture)
		if (isMyShop && userPreferences?.id === shopcard?.ownerId) {
			editUploadButton = !shopcard?.coverPicture ? (
				<div className="upload">{renderIcon('upload', 32, 32, '', this.editCoverPicture)}</div>
			) : (
				<div className="edit">{renderIcon('edit', 32, 32, '', this.editCoverPicture)}</div>
			);
		}

		const header = () => (
			<div className="profile-row">
				<div className="container">
					<div className="row align-items-center">
						<div className="profile-description col-md-8">
							<div className="flex-row d-flex align-items-center">
								<CoverPicture
									imageUrl={thumbUrl(picture, 'medium') || ''}
									hasPicture={Boolean(picture)}
									editFunction={isMyShop && userPreferences?.id === shopcard?.ownerId ? this.editProfilePicture : null}
									fromShop={true}
								/>
								<div>
									<h1>{name}</h1>
									<p className="bio">
										{description || `${t('Shop_ManageShop_Products_CreateProduct_Label_ShortDescription')}...`}
									</p>
								</div>
							</div>
						</div>
						<div className="profile-location col-md-4">
							<div className="flex-row d-flex">
								<img src={require('containers/Html/images/map.png')} className="profile-mapimage" />
								{this.office ? (
									<ShopCardOfficesMap
										changeOfficeId={this.handleLocationChange}
										shopId={this.office.shopId}
										officeId={this.office.id}
									/>
								) : null}
							</div>
						</div>
					</div>
				</div>
			</div>
		);

		const topPart = (isAuthenticated, signinRedirect) => (
			<div className="container">
				<div className="profile-actions row justify-content-center">
					<div
						className={`bsPortalBtn ${
							shopCardData?.isFollowed ? 'btnEllipseGreyWhite' : 'btnEllipseGreenWhite'
						} text-capitalize`}
						onClick={
							isMyShop
								? this.handleOnEditProfileClick
								: shopCardData?.isFollowed
								  ? () => this.unfollowShop(isAuthenticated, signinRedirect)
								  : () => this.followShop(isAuthenticated, signinRedirect)
						}
					>
						{isMyShop
							? t('User_UserCard_EditProfile')
							: shopCardData?.isFollowed
							  ? t('BSPortal_Common_Unfollow')
							  : t('BSPortal_Common_Follow')}
					</div>
					{shopLoaded && (
						<div className="follow-stats d-flex flex-row align-items-center">
							<p className="p14 text-lowercase followers-container" onClick={(e) => this.navigateToShopFollowers(e)}>
								<span className="count">{formatInteger(followersCount)}</span>&nbsp;{t('User_UserCard_Followers')}
							</p>
							<span className="topPart-dot">•</span>
							{renderIcon('star1')}
							<p className="p14 text-lowercase">
								<span className="count">{`${averageRating.toFixed(1)} (${votes})`}</span>
							</p>
						</div>
					)}
				</div>
				<div
					className="profile-images"
					style={{ backgroundImage: shopLoaded && `url(${thumbUrl(shopcard.coverPicture, 'banner')})` }}
				>
					<div className="editContainer">
						{approveButton} {shopcard?.coverPicture && editUploadButton}
					</div>
					{isMyShop && userPreferences?.id === shopcard?.ownerId && !shopcard?.coverPicture && (
						<div className="upload-container">
							<div className="profile-upload" onClick={this.editCoverPicture}>
								{<div className="upload">{renderIcon('upload', 32, 32, '')}</div>}
								<p>{t('Shop_ShopCard_UploadPicture')}</p>
								<p className="muted">{t('Shop_ShopCard_UploadPicture_Subtext')}</p>
							</div>
						</div>
					)}
				</div>
			</div>
		);

		const mobileHeader = (isAuthenticated, signinRedirect) => (
			<>
				<div
					className="profile-images"
					style={{ backgroundImage: shopLoaded && `url(${thumbUrl(shopcard.coverPicture, 'banner')})` }}
				>
					<div className="editContainer">
						{approveButton} {editUploadButton}
					</div>
				</div>
				<div className="profile-row">
					<div className="container">
						<div
							className={`bsPortalBtn ${
								shopCardData?.isFollowed ? 'btnEllipseGreyWhite' : 'btnEllipseGreenWhite'
							} text-capitalize`}
							onClick={
								isMyShop
									? this.handleOnEditProfileClick
									: shopCardData?.isFollowed
									  ? () => this.unfollowShop(isAuthenticated, signinRedirect)
									  : () => this.followShop(isAuthenticated, signinRedirect)
							}
						>
							{isMyShop
								? t('User_UserCard_EditProfile')
								: shopCardData?.isFollowed
								  ? t('BSPortal_Common_Unfollow')
								  : t('BSPortal_Common_Follow')}
						</div>
						<div className="profile-description-row row align-items-center justify-content-center">
							<div className="profile-description col-md-8">
								<div className="flex-column d-flex align-items-center">
									<CoverPicture
										imageUrl={thumbUrl(picture, 'medium') || ''}
										hasPicture={Boolean(picture)}
										fromShop={true}
									/>
									<div>
										<h1>{name}</h1>
										<p className="bio">
											{description || `${t('Shop_ManageShop_Products_CreateProduct_Label_ShortDescription')}...`}
										</p>
									</div>
								</div>
							</div>
							<div className="profile-actions row justify-content-center">
								{shopLoaded && (
									<div className="follow-stats d-flex flex-row align-items-center">
										<p
											className="p14 text-lowercase followers-container"
											onClick={(e) => this.navigateToShopFollowers(e)}
										>
											<span className="count">{formatInteger(followersCount)}</span>&nbsp;{t('User_UserCard_Followers')}
										</p>
										<span className="topPart-dot">•</span>
										{renderIcon('star1')}
										<p className="p14 text-lowercase">
											<span className="count">{`${averageRating.toFixed(1)} (${votes})`}</span>
										</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</>
		);

		const helmetElement: JSX.Element = (
			<Helmet
				title={name}
				link={[{ rel: 'canonical', href: shopUrl }]}
				meta={[
					{ property: 'og:title', content: name },
					{ property: 'og:image', content: picture },
					{ property: 'og:description', content: description },
					{ property: 'og:url', content: shopUrl },
					{ name: 'title', content: name },
					{ name: 'description', content: description },
					{ name: 'keywords', content: name },
				]}
			/>
		);

		const getOfficeTimes = (times, timezone) => {
			const openingTimes: string[][] = [];
			if (Array.isArray(times)) {
				for (let i = 0; i < 7; i++) {
					const time = times.find((t) => t && typeof t === 'object' && t.day === i);
					openingTimes.push([
						t('Day_' + i).substring(0, 1),
						time ? formatWorkTime(time, timezone) : t('Shop_ManageShop_Location_Label_OpeningTimes_Closed'),
					]);
				}
			}

			return openingTimes;
		};

		return (
			<LoadingOverlayWrapper active={!shopLoaded} spinner={true} text={t('BSPortal_Common_Loading')}>
				<AuthConsumer>
					{({ isAuthenticated, signinRedirect }) => {
						const office = this.office;

						// If multiple offices show selector first if no office id in params
						if (!this.props?.params?.officeId && shopcard?.offices?.length > 1) {
							return (
								<>
									<div className="container topPadding shopCardLocationSelector__container">
										<div className="row justify-content-center">
											<div className="col-xl-7 col-lg-8 col-12">
												<h1 className="shopCardLocationSelector__title">{t('Shop_ShopCard_ChooseALocation')}</h1>
												<div className="shopCardLocationSelector__shop">
													<AvatarSmall name={name} imageUrl={shopcard?.picture} fromShop={true} />
													<div className="shopCardLocationSelector__shopInfo">
														<p className="shopCardLocationSelector__shopMaintext">{shopcard?.name}</p>
														<p className="shopCardLocationSelector__shopSubtext">
															{shopcard?.offices?.length} {t('Shop_ShopCard_Locations')}
														</p>
													</div>
												</div>
											</div>
											{shopcard?.offices?.map((office) => {
												const todayWorkTime = (dayIndex: number): string => {
													const allTimes = getOfficeTimes(office?.officeTimes, office?.zoneInfo);
													const time = allTimes?.[dayIndex];
													return time?.[1] || t('Shop_ManageShop_Location_Label_OpeningTimes_Closed');
												};

												return (
													<div className="col-xl-7 col-lg-8 col-12" key={office.id}>
														<div
															onClick={() => {
																return this.handleLocationChange(office.id, false);
															}}
															className="shopCardLocationSelector__office"
														>
															<figure
																className="shopCardLocationSelector__officeImage"
																style={{ backgroundImage: 'url(' + thumbUrl(shopPictureToDisplay, 'thumbnail') + ')' }}
															/>
															<div className="shopCardLocationSelector__officeInfo">
																<p className="shopCardLocationSelector__officeMaintext">{office?.name}</p>
																<p className="shopCardLocationSelector__officeSubtext">
																	{renderIcon('clock')}
																	{todayWorkTime(momentWithTimezone(office?.zoneInfo).day())}
																</p>
															</div>
														</div>
													</div>
												);
											})}
										</div>
									</div>
									{helmetElement}
								</>
							);
						} else {
							return (
								<>
									<div className="profile shop" ref={this.mainRef}>
										<div className="portalTopPartLarge overview">
											{header()}
											{topPart(isAuthenticated, signinRedirect)}
										</div>
										<div className={`portalTopPartSmall ${isAuthenticated() ? '' : 'guest'}`}>
											{mobileHeader(isAuthenticated, signinRedirect)}
										</div>
										<div className="content">
											<div className="container">
												<div className="row">
													<div className="col-md-12">
														<Tabs
															name="shopcardtabs"
															tabComponent="div"
															handleSelect={(selectedTab) => {
																this.changeTabAndGetRequiredDataShort(null, selectedTab);
															}}
															selectedTab={
																selectedTab === c.SHOPCARD_TAB_OVERVIEW ? c.SHOPCARD_TAB_SERVICES : selectedTab
															}
															renderActiveTabContentOnly={true}
														>
															<div className="tabs justify-content-center">
																<TabLink key="servicestablink" to={c.SHOPCARD_TAB_SERVICES}>
																	<p>{t('User_ShopCard_Services')}</p>
																</TabLink>
																<TabLink key="abouttablink" to={c.SHOPCARD_TAB_ABOUT}>
																	<p>{t('Shop_ShopCard_Tabs_About')}</p>
																</TabLink>
																{isMyShop && <SettingsDropdown shopId={this.shop?.id} />}
															</div>
															<div className="profile-location-mobile col-md-4">
																<div className="flex-row d-flex">
																	<img src={require('containers/Html/images/map.png')} className="profile-mapimage" />
																	{this.office ? (
																		<ShopCardOfficesMap
																			changeOfficeId={this.handleLocationChange}
																			shopId={this.office.shopId}
																			officeId={this.office.id}
																		/>
																	) : null}
																</div>
															</div>
															<div className="tabs-wrapper d-flex justify-content-center" id={c.SHOPCARD_TAB_OVERVIEW}>
																<TabContent key="servicescontent" for={c.SHOPCARD_TAB_SERVICES} className="container">
																	{office ? (
																		<ShopCardOfficeStaff
																			officeId={office.id}
																			shopId={this.shop?.id}
																			onServicesMemberHandleClick={this.onServicesMemberHandleClick}
																		/>
																	) : null}
																	<div className="row">
																		{office ? (
																			<ShopCardServices
																				shopId={office.shopId}
																				officeId={office.id}
																				activeMembers={this.state?.activeMembers}
																				restrictedMode={restrictedMode}
																			/>
																		) : null}
																		<div className="subsection-info col-lg-2 col-md-12 customOffset shopInfoContainer">
																			{office ? <ShopCardOfficeDetails officeId={office.id} /> : null}
																		</div>
																	</div>
																</TabContent>
																<TabContent key="aboutcontent" for={c.SHOPCARD_TAB_ABOUT} className="container">
																	<div className="row">
																		<div className="col-lg-12 col-md-12">
																			<h1 className="title title1">{t('User_UserCard_About')}</h1>
																		</div>
																		<div className="col-lg-12 col-md-12">
																			<ShopAbout />
																		</div>
																	</div>
																	<div className="row meet-the-team">
																		<div className="col-lg-12 col-md-12">
																			<h1 className="title title1">{t('Shop_ShopCard_About_MeetTheTeam_Title')}</h1>
																		</div>
																		<div className="col-lg-12 col-md-12">
																			<ShopStaffMembers canEdit={isMyShop} officeId={office?.id} />
																		</div>
																	</div>
																	<div className="row">
																		<div className="col-lg-12 col-md-12">
																			<h1 className="title title2">{t('User_UserCard_Reviews')}</h1>
																		</div>
																		<div className="col-lg-12 col-md-12">
																			<ShopReviews officeLocation={office?.location} />
																		</div>
																	</div>
																</TabContent>
																<TabContent key="productscontent" for={c.SHOPCARD_TAB_PRODUCTS}>
																	<div className="actionContainer d-flex flex-row align-items-center justify-content-between">
																		<div>
																			<p className="p12 grayGigo">
																				{productSearchResults?.items.length} {t('User_ShopCard_Products')}
																			</p>
																		</div>
																		<div>
																			<ButtonRound type="button">
																				{renderIcon(
																					'filter',
																					undefined,
																					undefined,
																					'pointer',
																					this.props.toggleProductFilter,
																				)}
																			</ButtonRound>
																		</div>
																	</div>
																	<ProductSearchResults
																		goToCard={this.goToCard}
																		location={this.props.location}
																		usage={SearchUsage.ProductsShopCard}
																	/>
																</TabContent>
																<TabContent
																	key="followerstabcontent"
																	for={c.USERCARD_TAB_FOLLOWERS}
																	className="container"
																>
																	<div className="row justify-content-center">
																		<div className="col-12 col-lg-8 col-md-10 d-flex">
																			<h1 className="title">{t('User_UserCard_Followers')}</h1>
																		</div>
																		<div className="col-12 col-lg-8 col-md-10">
																			<ShopFollowers />
																		</div>
																	</div>
																</TabContent>
															</div>
														</Tabs>
													</div>
												</div>
											</div>
										</div>
									</div>
									{helmetElement}
								</>
							);
						}
					}}
				</AuthConsumer>
			</LoadingOverlayWrapper>
		);
	}
}

function mapStateToProps(state: IStore) {
	const shopCardData = state.shopcard;
	const userPreferences = state.userPreferences;

	return {
		shopCardData,
		userPreferences,
		isShopOwner: state.shopcard.isMyShop,
		productSearchResults: state.productSearchResults,
		baseUrlClient: state.fetchDefault.baseUrlClient,
	};
}

function mapDispatchToProps(dispatch: Dispatch<IStore>) {
	return {
		dispatch,
		changeTabAndGetRequiredData: (
			selectedTab: string,
			shopId: string,
			categoryId: number,
			order: number,
			r1: number,
			r2: number,
			r3: boolean,
			r4: string,
			r5: string,
			navigateToFollowers?: boolean,
		) =>
			dispatch(
				changeTabAndGetRequiredData(
					selectedTab,
					tabsNamespace,
					shopId,
					categoryId,
					order,
					r1,
					r2,
					r3,
					r4,
					r5,
					navigateToFollowers,
				),
			),
		followShop: (id: string) => dispatch(followShop(id)),
		showModal: (type: string, modalProps: any) => dispatch(showModal(type, modalProps)),
		closeModal: () => dispatch(closeModal()),
		updateProfileImage: (image: ICropImageData) => dispatch(updateProfileImage(image)),
		updateCoverImage: (image: ICropImageData) => dispatch(updateCoverImage(image)),
		resetData: () => dispatch(resetData()),
		setIsMyShop: (isMyShop: boolean) => dispatch(setIsMyShop(isMyShop)),
		getShopCardFollowButtonData: () => dispatch(getShopCardFollowButtonData()),
		unfollowShop: (id: string) => dispatch(unfollowShop(id)),
		getShopCardByCode: (code: string) => dispatch(getShopCardByCode(code, true, undefined, true)),
		setShopStatus: (id: string, status: ShopStatus) => dispatch(setShopStatus(id, status)),
		toggleProductFilter: () => dispatch(toggleProductFilter()),
	};
}

let ShopCard = withAuthContext(ShopCardWithForm);
ShopCard = connect(mapStateToProps, mapDispatchToProps)(ShopCard);

export { ShopCard };
